import { createSlice } from '@reduxjs/toolkit';

const PoleDetailsDataSlice = createSlice({
    name: 'PoleDetailsData',
    initialState: '',
    reducers: {
        setPoleDetailsData: (state, action) => {
            return action.payload;
        },
        resetPoleDetailsData: (state) => {
            return null;
        },
    },
});

export const { setPoleDetailsData, resetPoleDetailsData } = PoleDetailsDataSlice.actions;
export default PoleDetailsDataSlice.reducer;